import layout from './CoreFrameNavigation.html?raw';
import View from "@/Views/View";
import ComponentManager from "@/Management/ComponentManager";
import CoreFrameNavigationViewViewModel from "@/Components/CoreFrameNavigation/CoreFrameNavigationViewViewModel";
import StorageHelper from "@/Utility/StorageHelper";
import Utilities from "@/Utility/Utilities";
import NavigationService from "@/Management/NavigationService";

export default class CoreFrameNavigationView extends View {
    private view: JQuery<HTMLElement>;

    constructor(private viewModel: CoreFrameNavigationViewViewModel, private element?: JQuery<HTMLElement>) {
        super();
    }

    public getView(): JQuery<HTMLElement> {
        if (this.view != null) {
            return this.view;
        }

        this.view = this.applyBindings(this.element, this.viewModel, layout);
        this.applyResizeBindings();
        this.applySearchClearClick();
        this.applySearchBoxClick();
        this.applyHotkey();

        return this.view;
    }
    
    private applyResizeBindings() {
        const navigation = $('[data-region="Navigation"]')
        const content = $('[data-region="Content"]')

        const navigationExpandedBinding = StorageHelper.bind("WireframeExpanded", true);
        navigationExpandedBinding.subscribe((isExpanded) => {
            const width = isExpanded ? 300 : 60;

            navigation.animate({ width: width }, 100);
            content.animate({ marginLeft: width }, 100);
            $(window).trigger('resize');
            
            this.flagNavEntries(navigation, isExpanded);
            if (!isExpanded)
                this.viewModel.collapseWholeTree();
            else 
                this.viewModel.restoreTreeState();
            
            this.viewModel.isNavigationExpanded(isExpanded);
        });

        navigationExpandedBinding.notifySubscribers(navigationExpandedBinding());
    }
    
    private applySearchBoxClick() {
        const searchBox = this.view.find('.c-textbox');
        if (!searchBox || searchBox.length === 0)
            return;

        this.addNativeEventHandler('pointerup', searchBox[0], (_) => {
            if (this.viewModel.isNavigationExpanded())
                return;

            StorageHelper.set("WireframeExpanded", true);
            $(window).trigger("resize");
        });
    }
    
    private applySearchClearClick() {
        const clearIcon = this.view.find('.clear-icon');
        if (!clearIcon || clearIcon.length === 0)
            return;
        
        this.addNativeEventHandler('pointerup', clearIcon[0], (_) => {
           this.viewModel.searchBox.value('');
        });
    }
    
    private applyHotkey() {
        let $input = this.view.find('.c-textbox').children('input');
        
        this.applyBindingsToNode(this.view, {
            hotkey: {
                shortcut: 'alt+m',
                handler: () => {
                    // wir erlauben Alt+M nur, wenn kein Popup-Dialog offen ist
                    if (NavigationService.getInstance().getModalViewFactories() === 0)
                        $input.focus();
                    
                    return false;
                }
            }
        });
    }
    
    private flagNavEntries(navigation: JQuery<HTMLElement>, isExpanded: boolean) {
        // In der mobilen Ansicht wird die Navigation direkt eingeklappt, weshalb das flaggen möglicherweise nicht direkt klappen kann 
        // (weil das Element bspw. noch nicht im DOM vorhanden ist). Daher warten wir maximal 30 Sekunden auf die Einträge bevor wir abbrechen.
        this.waitForNavigationEntries(navigation).then(result => {
            if (!result)
                return;

            const entries = navigation.find('.navigation-entries').first();
            if (isExpanded)
                entries?.removeClass('nav-minimized');
            else
                entries?.addClass('nav-minimized');
        })

        const searchArea = navigation.find('.search-wrapper').first();
        const spacer = navigation.find('.line-wrap').first();
        if (isExpanded) {
            searchArea?.removeClass('nav-minimized');
            spacer?.removeClass('nav-minimized');
        } else {
            searchArea?.addClass('nav-minimized');
            spacer?.addClass('nav-minimized');
        }
    }

    private async waitForNavigationEntries(root: JQuery): Promise<boolean> {
        return new Promise((resolve) => {
            const alreadyExist = root[0]?.querySelector('.navigation-entries');
            if (alreadyExist) {
                resolve(true);
                return;
            }
            
            const observerTimeoutId = window.setTimeout(() => {
                observer?.disconnect();
                resolve(false);
            }, 30_000);

            const observer = new MutationObserver(() => {
                const existing = root[0]?.querySelector('.navigation-entries');
                if (existing) {
                    observer.disconnect();
                    resolve(true);
                    window.clearTimeout(observerTimeoutId);
                }
            });

            observer.observe(document, {childList: true, subtree: true});
        });
    }
}

ComponentManager.setView('NavigationView', CoreFrameNavigationView, 'RADPresentation.HTMLClient.DefaultViewExtensions');